import React from 'react';
import { Label } from '../../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';

const MONTHS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

function yearOptions() {
  const y = new Date().getFullYear();
  const out = [];
  for (let i = y - 3; i <= y + 1; i += 1) {
    out.push(i);
  }
  return out;
}

export default function AttendanceMonthPicker({ month, monthYear, onChange, className = '' }) {
  return (
    <div className={`flex flex-wrap items-end gap-3 ${className}`}>
      <div className="space-y-1 min-w-[140px]">
        <Label className="text-xs text-muted-foreground">Month</Label>
        <Select
          value={String(month)}
          onValueChange={(v) => onChange({ month: parseInt(v, 10), monthYear })}
        >
          <SelectTrigger>
            <SelectValue placeholder="Month" />
          </SelectTrigger>
          <SelectContent>
            {MONTHS.map((m) => (
              <SelectItem key={m.value} value={String(m.value)}>
                {m.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1 min-w-[100px]">
        <Label className="text-xs text-muted-foreground">Year</Label>
        <Select
          value={String(monthYear)}
          onValueChange={(v) => onChange({ month, monthYear: parseInt(v, 10) })}
        >
          <SelectTrigger>
            <SelectValue placeholder="Year" />
          </SelectTrigger>
          <SelectContent>
            {yearOptions().map((y) => (
              <SelectItem key={y} value={String(y)}>
                {y}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
